import React from 'react';
import {WithPermission} from 'admin-on-rest';
import {resolveAccess} from '../shared/authFunctions';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {Card, CardHeader, CardText, CardActions} from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import ListIcon from 'material-ui/svg-icons/action/view-list';
import ToggleIcon from 'material-ui/svg-icons/toggle/check-box';
import {fuseConfigurationIcon as ConfigurationIcon} from './configuration';
import {fuseModeIcon as ModeIcon} from './setMode';
import {dashStyles} from '../shared/styles-dashboard';
import {FlatButton} from 'material-ui';

export default () => (
    <div>
        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['configuration'])}>
            <Card style={{...dashStyles.marginBottom}}>
                <ConfigurationIcon style={dashStyles.dashIcon}/>
                <ViewTitle title="Configuration"/>
                <CardText>
                    <p>
                        Modify Admin settings for your business.</p>
                    <p>
                        Here you can adjust visibility settings, test or live mode for the POS System.
                    </p>
                    <hr style={dashStyles.break}/>
                </CardText>
            </Card>

            {/* Admin Mode */}
            <Card style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.marginBottom}}
                  className="listCard">
                <CardHeader
                    title="Admin Mode"
                    subtitle="Toggle Admin from Live Mode to Test Mode for Inventory and Sales testing."
                    avatar={<Avatar icon={<ModeIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton icon={<ToggleIcon/>} label="Toggle Mode" href="#/Configuration/Mode"/>
                </CardActions>
            </Card>
        </WithPermission>

        <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['configuration_vo'])}>
            <Card style={{...dashStyles.marginBottom}}>
                <ConfigurationIcon style={dashStyles.dashIcon}/>
                <ViewTitle title="Configuration"/>
                <CardText>
                    <p>View Admin settings for your business.</p>
                    <hr style={dashStyles.break}/>
                </CardText>
            </Card>
        </WithPermission>

        {/* Configurations */}
        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['configuration', 'configuration_vo'])}>
            <Card
                style={{...dashStyles.listCard, ...dashStyles.listCardHalf, ...dashStyles.listCardLast, ...dashStyles.marginBottom}}
                className="listCard">
                <CardHeader
                    title="Configurations"
                    subtitle="Pairs of Configuration values for the POS System."
                    avatar={<Avatar icon={<ConfigurationIcon/>} style={dashStyles.avatar}/>}
                />
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="List Configurations" href="#/Configurations"/>
                </CardActions>
            </Card>

        </WithPermission>
    </div>
);



// WEBPACK FOOTER //
// ./src/Fuse/Setting/dashboard.js